import React from "react";
import { Form } from "antd";
import { OPTIONS } from "../MapJob";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";

function WidgetJobCategoryCode() {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="직종코드"
        fieldName={"jobs_cd_list"}
        options={OPTIONS.map(({ jobs_cd, label, iconCode }) => ({
          value: jobs_cd,
          label,
          // iconCode,
        }))}
        colSpan={24}
      />
    </Form.Item>
  );
}

export default WidgetJobCategoryCode;
